import React from 'react';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import './LimitInfoField.scss';


const LimitList = ({
  limitList,
  isReward,
}) => {
  if (!limitList || !limitList?.length) {
    return null;
  };

  const limitText = isReward ? "reward" : "transaction";

  return (
    <>
      <CustomTitleLabel title={`Maximum ${limitText} limit`} />

      {
        limitList?.map((item, index) => (
          <div key={index} className='limit-info-field-single'>
            <span className='limit-info-field-text'>
              - {
                item?.customDisplayPeriod 
                || `${item?.displayPeriod} maximum ${limitText} limit`
              }
            </span>
            {item?.receiptSource && (
              <span className='limit-info-field-text limit-info-field-text-margin-left'>
                - Receipt source: {item?.receiptSource}
              </span>
            )}
            <span className='limit-info-field-text limit-info-field-text-margin-left'>
              - Limit: {item?.displayLimit}
            </span>
            <span className='limit-info-field-text limit-info-field-text-margin-left'>
              - Accumulated: {item?.displayAccumulated}
            </span>
          </div>
        ))
      }
    </>
  )
}


const LimitInfoField = ({
  title,
  reachLimitInfo = {}
}) => {
  return (
    <div className='limit-info-field-container'>
      <label className="create-section-title">{title}</label>
      <LimitList
        limitList={reachLimitInfo?.rewardLimitList}
        isReward
      />
      <LimitList
        limitList={reachLimitInfo?.transactionLimitList}
        isReward={false}
      />

      {
        reachLimitInfo?.showTransactionValue && (
          <>
            <CustomTitleLabel title={"Original transaction value"} />
            <label className="custom-record-normal-font custom-timeline-time-color list-new-line">
              {reachLimitInfo?.originalTransactionValue}
            </label>
          </>
        )
      }

      <CustomTitleLabel title={"Original reward from this record"} />
      <label className="custom-record-normal-font custom-timeline-time-color list-new-line">
        {reachLimitInfo?.displayOriginalReward}
      </label>

      <CustomTitleLabel title={"Final reward"} />
      <label className="custom-record-normal-font custom-timeline-time-color list-new-line">
        {reachLimitInfo?.displayFinalReward}
      </label>
    </div>
  )
}

export default LimitInfoField
